import Instagram from '../images/icons/instagram.svg'
import Twitter from '../images/icons/twitter.svg'
import Facebook from '../images/icons/facebook.svg'
import InstagramDark from '../images/icons/instagram-dark.svg'
import TwitterDark from '../images/icons/twitter-dark.svg'
import FacebookDark from '../images/icons/facebook-dark.svg'

const socialData = [
  {
    name: 'Instagram',
    url: 'https://instagram.com/kendallawhitman',
    icon: Instagram,
    iconDark: InstagramDark,
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com/KendallWhitmanPhotography',
    icon: Facebook,
    iconDark: FacebookDark,
  },
  // {
  //   name: 'Twitter',
  //   url: 'https://twitter.com/kendallwhitman',
  //   icon: Twitter,
  //   iconDark: TwitterDark,
  // },
]

export default socialData
